/* eslint-disable */
import {
    ERROR_ACTION, SET_UPLOAD_MARKSHEET_LIST, SET_APPLICATION_STAGES_VIEW, SET_ALL_STAGES_LIST, SET_ALL_SUBJECTS_LIST, SET_ADVT_DETAILS, SET_ADVT_POSTS_DATA, SET_ALL_STAGES_CONFIG_LIST, SET_ALL_REUPLOAD_DOCLIST, SET_ALL_REDOWNLOAD_DOCLIST, SET_EXAM_PAPER_SET, SET_EXAM_PAPER_QUESTIONS_LIMIT,
    SET_EXAM_SUBJECTS_FOR_OBJECTION, SET_OBJECTION_ANSWER_KEY_DATA, SET_EXAM_SUBJECTS_FOR_OBJECTION_FILE, SET_OBJECTION_QUESTIONS, SET_ALL_OBJECTION_FILES_DATA, SET_ALL_OBJECTION_FILES_PAGE_NO_COUNTER, SET_OBJECTION_FILE_IMAGE, SET_EXAM_LIST_DETAILS_FOR_OBJECTION_REPORT, SET_EXAM_SUBJECT_LIST_FOR_OBJECTION_REPORT,
    SET_EXAM_SUBJECT_QUESTIONS_LIST_FOR_OBJECTION_REPORT, SET_OBJECTION_REPORT_DATA, SET_OBJECTION__COUNT_REPORT_DATA, SET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS, SET_SEARCH_ADMIT_CARD_LIST, SET_ADMIT_CARD_SEARCH_LIST_PAGE_NO_COUNTER, GET_ALL_CANDIDATE_INFO, SET_PROFILE_SUMMARY_INFO_DATA, SET_PROFILE_INFO_DISPLAY_DATA,
    SET_VENUE_DETAILS, GET_EXAM_STAFF_ERROR_LIST_FILE, SET_SCHEDULE_TYPE_LIST, SET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES, GET_INTERVIEW_SCHEDULE_LIST, SET_INTERVIEW_REPORT_DATA, SET_CANDIDATE_LIST,
    GET_APPLICATION_LISTING, SET_APPROVED_VENUE_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION, SET_LOOKUP_OPTIONS_DATA, SET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT,SET_INTERVIEW_INSTRUCTIONS_LIST, GET_APPLICATION_LISTING_FOR_INTERVIEW_PT_LETTER,
    SET_GET_ACTIVE_ADVERTISEMENT, SET_GET_PAST_ADVERTISEMENT, SET_YEAR
} from "../../../common/constants/ActionTypes";

// import { SET_APPLICATION_STAGES_VIEW, SET_YEAR, SET_GET_ACTIVE_ADVERTISEMENT, SET_GET_PAST_ADVERTISEMENT, SET_ADVT_DETAILS} from "../../../common/constants/ActionTypes";

const initialState = {
    errorMessage: "",
    showApplicationStagesDetails: false,
    yearList: [],
    activeAdvertisement: [],
    pastAdvertisement: [],
    advertisementDetails: [],
    uploadedMarksheetList: [],
    allStagesList: [],
    advertisementPostsData: [],
    allStageConfigList: [],
    allSubjectsList: [],
    allReUploadApplicationDocList: [],
    allReDownloadApplicationDocList: [],
    getExamPaperSet: [],
    getExamPaperQuestionsLimit: [],
    getExamSubjectsForObjection: [],
    getObjectionAnsweKeyDataList: [],
    getExamSubjectsListForObjectionFile: [],
    getObjectionQuestionsList: [],
    getAllObjectionFilesList: [],
    getAllObjectionFilesPageNoCounter: 0,
    objectionFilesUploadedPhoto: {},
    getAllObjectionReportExamsList: [],
    getAllObjectionReportExamSubjectsList: [],
    getAllObjectionReportExamSubjectQuestionsList: [],
    getObjectionReportDetails: [],
    getObjectionReportCountDetails: [],
    getObjectionAttachmentReportApplicationsData: [],
    getSearchAdmitCardListDetails: [],
    getAdmitCardSearchListPageNoCounter: 0,
    admitCardData: {},
    profileSummaryInfo: [],
    profileDetailsInfo: [],
    getVenueDetailsList: [],
    getApprovedVenueDetailsList: [],
    getExamStaffErrorFileList: [],
    getScheduleTypeList: [],
    getInterviewPtLetterDropdownValues: [],
    getInterviewPhaseDetails: [],
    getInterviewScheduleList: [],
    getInterviewReportList: [],
    getCandidateList: [],
    getApplicationDetailsForApplicationProfileReport: [],
    getInterviewInstructionsList: [],
    getApplicationListingArrForInterviewPtLetter: []
}

export default function applicationManagementReducer(state = initialState, action) {
    switch (action.type) {
        case SET_APPLICATION_STAGES_VIEW:
            return {
                ...state,
                showApplicationStagesDetails: action.payload
            }
        case SET_YEAR:
            return {
                ...state,
                yearList: action.payload
            }
        case SET_GET_ACTIVE_ADVERTISEMENT:
            return {
                ...state,
                activeAdvertisement: action.payload
            }
        case SET_GET_PAST_ADVERTISEMENT:
            return {
                ...state,
                pastAdvertisement: action.payload
            }
        case SET_ADVT_DETAILS:
            return {
                ...state,
                advertisementDetails: action.payload
            }
        case ERROR_ACTION:
            return {
                ...state,
                errorMessage: action.payload
            }
        case SET_UPLOAD_MARKSHEET_LIST:
            return {
                ...state,
                uploadedMarksheetList: action.payload
            }
        case SET_ALL_STAGES_LIST:
            return {
                ...state,
                allStagesList: action.payload
            }
        case SET_ADVT_DETAILS:
            return {
                ...state,
                advertisementDetails: action.payload
            }
        case SET_ADVT_POSTS_DATA:
            return {
                ...state,
                advertisementPostsData: action.payload
            }
        case SET_ALL_STAGES_CONFIG_LIST:
            return {
                ...state,
                allStageConfigList: action.payload
            }
        case SET_ALL_SUBJECTS_LIST:
            return {
                ...state,
                allSubjectsList: action.payload
            }
        case SET_ALL_REUPLOAD_DOCLIST:
            return {
                ...state,
                allReUploadApplicationDocList: action.payload
            }
        case SET_ALL_REDOWNLOAD_DOCLIST:
            return {
                ...state,
                allReDownloadApplicationDocList: action.payload
            }
        case SET_EXAM_PAPER_SET:
            return {
                ...state,
                getExamPaperSet: action.payload
            }
        case SET_EXAM_SUBJECTS_FOR_OBJECTION:
            return {
                ...state,
                getExamSubjectsForObjection: action.payload
            }
        case SET_OBJECTION_ANSWER_KEY_DATA:
            return {
                ...state,
                getObjectionAnsweKeyDataList: action.payload
            }
        case SET_EXAM_SUBJECTS_FOR_OBJECTION_FILE:
            return {
                ...state,
                getExamSubjectsListForObjectionFile: action.payload
            }
        case SET_OBJECTION_QUESTIONS:
            return {
                ...state,
                getObjectionQuestionsList: action.payload
            }
        case SET_EXAM_PAPER_QUESTIONS_LIMIT:
            return {
                ...state,
                getExamPaperQuestionsLimit: action.payload
            }
        case SET_ALL_OBJECTION_FILES_DATA:
            return {
                ...state,
                getAllObjectionFilesList: action.payload
            }
        case SET_ALL_OBJECTION_FILES_PAGE_NO_COUNTER:
            return {
                ...state,
                getAllObjectionFilesPageNoCounter: action.payload
            }
        case SET_OBJECTION_FILE_IMAGE:
            return {
                ...state,
                objectionFilesUploadedPhoto: action.payload
            }
        case SET_EXAM_LIST_DETAILS_FOR_OBJECTION_REPORT:
            return {
                ...state,
                getAllObjectionReportExamsList: action.payload
            }
        case SET_EXAM_SUBJECT_LIST_FOR_OBJECTION_REPORT:
            return {
                ...state,
                getAllObjectionReportExamSubjectsList: action.payload
            }
        case SET_EXAM_SUBJECT_QUESTIONS_LIST_FOR_OBJECTION_REPORT:
            return {
                ...state,
                getAllObjectionReportExamSubjectQuestionsList: action.payload
            }
        case SET_OBJECTION_REPORT_DATA:
            return {
                ...state,
                getObjectionReportDetails: action.payload
            }
        case SET_OBJECTION__COUNT_REPORT_DATA:
            return {
                ...state,
                getObjectionReportCountDetails: action.payload
            }
        case SET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS:
            return {
                ...state,
                getObjectionAttachmentReportApplicationsData: action.payload
            }
        case SET_SEARCH_ADMIT_CARD_LIST:
            return {
                ...state,
                getSearchAdmitCardListDetails: action.payload
            }
        case SET_ADMIT_CARD_SEARCH_LIST_PAGE_NO_COUNTER:
            return {
                ...state,
                getAdmitCardSearchListPageNoCounter: action.payload
            }
        case GET_ALL_CANDIDATE_INFO:
            return {
                ...state,
                admitCardData: action.payload
            }
        case SET_PROFILE_SUMMARY_INFO_DATA:
            return {
                ...state,
                profileSummaryInfo: action.payload
            }
        case SET_PROFILE_INFO_DISPLAY_DATA:
            return {
                ...state,
                profileDetailsInfo: action.payload
            };
        case SET_VENUE_DETAILS:
            return {
                ...state,
                getVenueDetailsList: action.payload
            };
        case GET_APPLICATION_LISTING:
            return {
                ...state,
                getapplicationList: action.payload
            };
        case SET_APPROVED_VENUE_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION:
            return {
                ...state,
                getApprovedVenueDetailsList: action.payload
            };
        case GET_EXAM_STAFF_ERROR_LIST_FILE:
            return {
                ...state,
                getExamStaffErrorFileList: action.payload
            };
        case SET_SCHEDULE_TYPE_LIST:
            return {
                ...state,
                getScheduleTypeList: action.payload
            };
        case SET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES:
            return {
                ...state,
                getInterviewPtLetterDropdownValues: action.payload
            };
        case SET_LOOKUP_OPTIONS_DATA:
            return {
                ...state,
                getInterviewPhaseDetails: action.payload
            };
        case GET_INTERVIEW_SCHEDULE_LIST:
            return {
                ...state,
                getInterviewScheduleList: action.payload
            };
        case SET_INTERVIEW_REPORT_DATA:
            return {
                ...state,
                getInterviewReportList: action.payload
            };
        case SET_CANDIDATE_LIST:
            return {
                ...state,
                getCandidateList: action.payload
            };
        case SET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT:
            return {
                ...state,
                getApplicationDetailsForApplicationProfileReport: action.payload
            };
        case SET_INTERVIEW_INSTRUCTIONS_LIST:
            return {
                ...state,
                getInterviewInstructionsList: action.payload
            };
        case GET_APPLICATION_LISTING_FOR_INTERVIEW_PT_LETTER:
            return {
                ...state,
                getApplicationListingArrForInterviewPtLetter: action.payload
            };
        default:
            return state;
    }
}